/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import {
  Input,
  Button,
  RadioGroup,
  RadioOption,
  Checkbox,
  Dropdown,
  DropdownOption,
  ToggleSwitch,
} from "@abb/abb-common-ux-react";
import {
  defaultMeasurementSettingData,
  MeasurementSetting,
} from "../../models/settings/MeasurementSettings";

interface IProps {
  settings: MeasurementSetting;
  graphSettings: any[];
  imageURL: any;
  base64URL: any;
  logoName: any;
  onChangeHeader: (v: string) => void;
  onChangeSubheader: (v: string) => void;
  onChangeFooter: (v: string) => void;
  onFileChange: (e: any) => void;
  onChangeFileName: (v: string) => void;
  onChangeFormat: (v: string) => void;
  onChangeReportLocation: (v: string) => void;
  onChangeAutoReport: () => void;
  onChangeValueReport: () => void;
  onChangePositionReport: () => void;
  onChangeReelReport: () => void;
  onChangeGraphReport: () => void;
  onChangeGraphType: (e: any) => void;
  onChangeGenerateXML: (e: any) => void;
}

interface ILandingState {
  settings: MeasurementSetting;
  imageArray: any[];
}

export default class ReportSettingLanding extends React.Component<
  IProps,
  ILandingState
> {
  private _mount: boolean = false;
  private _settingsData: any;
  private _dropDownValue: any;
  private fileRef: any = React.createRef<HTMLDivElement>();
  private locationRef: any = React.createRef<HTMLDivElement>();

  constructor(props: IProps) {
    super(props);
    this._mount = true;

    this.state = {
      settings: defaultMeasurementSettingData,
      imageArray: [],
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  componentDidMount() {
    this._mount = true;

    if (this.locationRef.current !== null) {
      this.locationRef.current.setAttribute("directory", "");
      this.locationRef.current.setAttribute("webkitdirectory", "");
    }
  }

  onFileBrowse(): void {
    this.fileRef.current.click();
  }

  onLocationBrowse = () => {
    this.locationRef.current.click();
  };

  public render() {
    this._dropDownValue = {
      label: this.props.settings?.selectedGraphType.name,
      value: this.props.settings?.selectedGraphType.id,
    };
    return (
      <Translation>
        {(t) => (
          <div className="page-layout h-100">
            <div className="summary-layout mt-4">
              <div className="row">
                <div className="col-7">
                  <div className="row">
                    <label className="col-5">
                      {t(CONSTANTS.LABLE_REPORT_HEAD)}
                    </label>
                    <Input
                      dataType="text"
                      className="col-7"
                      placeholder={t(CONSTANTS.LABLE_REPORT_HEAD)}
                      value={t(this.props.settings?.header) ?? ""}
                      onValueChange={(v) => this.props.onChangeHeader(v)}
                    />
                  </div>

                  <div className="row mt-3">
                    <label className="col-5">
                      {t(CONSTANTS.LABEL_REPORT_SUBHEAD)}
                    </label>
                    <Input
                      dataType="text"
                      className="col-7"
                      placeholder={t(CONSTANTS.LABEL_REPORT_SUBHEAD)}
                      value={t(this.props.settings?.subHeader) ?? ""}
                      onValueChange={this.props.onChangeSubheader}
                      maxLength={20}
                    />
                  </div>

                  <div className="row mt-3">
                    <label className="col-5">
                      {t(CONSTANTS.LABEL_FOOTER)}{" "}
                    </label>
                    <Input
                      dataType="text"
                      className="col-7"
                      placeholder={t(CONSTANTS.LABEL_FOOTER)}
                      value={t(this.props.settings?.footer) ?? ""}
                      onValueChange={this.props.onChangeFooter}
                      maxLength={20}
                      showValidationBarWhenInvalid={false}
                    />
                  </div>

                  <div className="row mt-3">
                    <label className="col-5">{t(CONSTANTS.LABEL_LOGO)}</label>
                    <Input
                      className="col-4"
                      dataType="text"
                      placeholder={t(CONSTANTS.LABEL_LOGO)}
                      value={this.props.logoName}
                      disabled={true}
                      maxLength={20}
                    />
                    <input
                      type="file"
                      id="file"
                      ref={this.fileRef}
                      accept="image/*"
                      // tslint:disable-next-line: jsx-no-lambda
                      onChange={(e) => this.props.onFileChange(e)}
                      style={{ display: "none" }}
                    />
                    <Button
                      text={t(CONSTANTS.LABEL_BROWSE)}
                      id="btnAddSelected"
                      type="primary-black"
                      shape="pill"
                      sizeClass="small"
                      className="col-2"
                      // tslint:disable-next-line: jsx-no-lambda
                      onClick={() => this.onFileBrowse()}
                    />
                  </div>
                  <div className="row mt-3">
                    <label className="col-5">
                      {t(CONSTANTS.LABEL_GRAPH_TYPE)}
                    </label>
                    <Dropdown
                      className="col-7"
                      style={{ padding: "0px 15px" }}
                      placeholder={t(CONSTANTS.LABEL_GRAPH_TYPE)}
                      value={this._dropDownValue}
                      onChange={(value) => this.props.onChangeGraphType(value)}
                    >
                      {this.props.graphSettings.map((o) => (
                        <DropdownOption
                          key={o.id}
                          label={o.name}
                          value={o.id}
                        />
                      ))}
                    </Dropdown>
                  </div>

                  <div className="row mt-3">
                    <label className="col-5">
                      {t(CONSTANTS.LABEL_FILE_PREFIX)}
                    </label>
                    <Input
                      className="col-7"
                      dataType="text"
                      placeholder={t(CONSTANTS.PLACEHOLDER_FILE_PREFIX)}
                      value={t(this.props.settings?.fileNamePrefix) ?? ""}
                      // tslint:disable-next-line: jsx-no-lambda
                      onValueChange={this.props.onChangeFileName}
                    />
                  </div>

                  {/* <div className="row mt-3">
                      <label className="col-5">{t(CONSTANTS.LABEL_SAVE_FORMAT)}</label>
                      <RadioGroup
                        sizeClass={"small"}
                        value={this.props.settings.saveFormatPdf}
                        orientation="horizontal"
                        // tslint:disable-next-line: jsx-no-lambda
                        onChange={(v) => this.props.onChangeFormat(v)}
                      >
                        <RadioOption text={t(CONSTANTS.PDF_FORMAT_OPTION)} value={CONSTANTS.PDF_FORMAT_OPTION} />
                        <RadioOption text={t(CONSTANTS.EXCEL_FORMAT_OPTION)} value={CONSTANTS.EXCEL_FORMAT_OPTION} />

                      </RadioGroup>
                    </div> */}

                  {/* <div className="row mt-3">
                      <label className="col-5">{t(CONSTANTS.LABEL_LOCATION)}</label>
                      <Input
                        className="col-7"
                        dataType="text"
                        placeholder={t(CONSTANTS.SELECT_XML_PLACEHOLDER)}
                        value={this.props.settings.reportSaveLocation}
                        // tslint:disable-next-line: jsx-no-lambda
                        onValueChange={(v) => this.props.onChangeReportLocation(v)}
                      />
                    </div> */}
                  {/* <div className="row mt-3">
                      <label className="col-5">{t(CONSTANTS.LABEL_FILE_PREFIX)}</label>
                      <ToggleSwitch
                        showIcons={true}
                        className="spinner-position"
                        value={this.props.settings.generateXML}
                        onChange={(value: any) => this.props.onChangeGenerateXML(value)}
                        />
                    </div> */}
                </div>
                <div className="col-4 flex-start">
                <div> {this.props.base64URL ? (
                    <img
                      className="responsive logo-size"
                      height="70"
                      width="100"
                      src={this.props.base64URL}
                      alt={t(CONSTANTS.NO_IMAGE_FOUND)}
                    />
                  ) : this.props.imageURL ? (
                    <img
                      className="responsive logo-size"
                      height="70"
                      width="100"
                      src={`${window.LMS.SAMPLE_API_URL}/Settings/General/logo`}
                      alt={t(CONSTANTS.NO_IMAGE_FOUND)}
                    />
                  ) : null}
                
                    <div className="image-note sample_remarks">
                    <span className="required_header_blue">*</span>{" "}
                    {t("Please upload image with exact size : 70 x 100")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}
